import { Alert, Tabs } from "@jhool-io/fe-components";
import { useSearchParams } from "react-router-dom";
import CallHistoryList from "./CallHistoryList/CallHistoryList";
import SmsHistoryList from "./SmsHistoryList/SmsHistoryList";

export default function ClientCommunications() {
    const [searchParams, setSearchParams] = useSearchParams();

    const subTabInUrl = searchParams.get("communications_subtab");

    const handleSubTabInView = (subTab: string) => {
        searchParams.set("communications_subtab", subTab);
        setSearchParams(searchParams);
    };

    const tabItems = [
        {
            label: "SMS history",
            key: "sms",
            children: <SmsHistoryList />,
            onClick: () => handleSubTabInView("sms"),
        },
        {
            label: "Call history",
            key: "calls",
            children: <CallHistoryList />,
            onClick: () => handleSubTabInView("calls"),
        },
    ];

    return (
        <>
            <Alert
                type="info"
                classNames="mb-[--spacing-header]"
                description="SMS history, call history and their notes are not specific to a practice. They are matched to this client's phone number, so they are the same in every practice the client belongs to."
            />
            <Tabs
                items={tabItems}
                size="medium"
                className="w-full rounded-none"
                defaultActiveKey={subTabInUrl || tabItems[0].key}
            />
        </>
    );
}
